import { useState } from 'react';
import classNames from 'classnames';
import {
  MediaFormatHelper,
  Field2 as Field,
  VibeModal,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Information({
  className = '',
  name = '',
  mediaFormat = '',
  locationSpec = [],
  disableInput = false,
  onUpdate = () => {},
}) {
  const [confirmChangeMediaFormat, setConfirmChangeMediaFormat] = useState(false);
  const [newMediaFormat, setNewMediaFormat] = useState(null);

  /**
   * When the Media Format field is changed
   * ask to confirm removing all locations for the segment
   */
  const onChangeMediaFormat = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    if (locationSpec.length > 0) {
      // show confirmation modal that the locations will be reset
      setConfirmChangeMediaFormat(true);
      setNewMediaFormat(value);
    } else {
      // segment has no locations, allow changing without confirmation
      onUpdate({
        mediaFormat: value,
      });
    }
  };

  /**
   * Confirm changing the Media Format
   */
  const onConfirmChangeMediaFormat = () => {
    onUpdate({
      mediaFormat: newMediaFormat,
      // reset the locations when the media format is changed
      locations: {},
      locationSpec: [],
      locationsData: {
        companies: [],
        locations: [],
      },
      numberOfLocations: 0,
    });

    setConfirmChangeMediaFormat(false);
    setNewMediaFormat(null);
  };

  /**
   * Cancel changing the Media Format
   */
  const onCancelChangeMediaFormat = () => {
    setConfirmChangeMediaFormat(false);
    setNewMediaFormat(null);
  };

  /**
   * When a field is changed
   */
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  return (
    <>
      <Grid className={classNames('Information', className)} spacing={2} container>
        <Grid size={12}>
          <Field
            type="text"
            label="Name"
            name="name"
            placeholder="Name"
            value={name}
            disabled={disableInput}
            tabIndex={10}
            testId="target-group-name-input"
            onChange={onChange}
            autoFocus
            required
          />
        </Grid>

        <Grid size={12}>
          <Field
            type="select"
            label="Media Format"
            name="mediaFormat"
            value={mediaFormat}
            options={MediaFormatHelper.list({ includeEmpty: true })}
            disabled={disableInput}
            tabIndex={11}
            testId="target-group-media-format-select"
            onChange={onChangeMediaFormat}
            required
          />
        </Grid>
      </Grid>

      <VibeModal
        show={confirmChangeMediaFormat}
        type="confirm"
        title="Change Media Format"
        text={(
          <div>
            Changing the media format will reset the assigned locations for this target group
            <br />
            <br />
            This action cannot be undone.
          </div>
        )}
        testIds={{
          root: 'target-group-change-media-format-dialog',
          confirm: 'target-group-change-media-format-confirm-button',
          cancel: 'target-group-change-media-format-cancel-button',
        }}
        onConfirm={onConfirmChangeMediaFormat}
        onClose={onCancelChangeMediaFormat}
      />
    </>
  );
}

export default Information;
